import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
const SESSION_EXPIRED = "Session expired — sign in again.";
function isUnauthorizedError(e) {
    return (typeof e === "object" &&
        e !== null &&
        "status" in e &&
        e.status === 401);
}
/** Modular panel: auto-refreshes on an interval. */
export function LivePanel({ title, intervalMs = 5000, load, children, }) {
    const [error, setError] = useState(null);
    const [stopped, setStopped] = useState(false);
    const consecutiveUnauthorized = useRef(0);
    const inFlight = useRef(false);
    useEffect(() => {
        if (stopped)
            return;
        let active = true;
        const run = () => {
            if (inFlight.current)
                return;
            inFlight.current = true;
            void load()
                .then(() => {
                if (!active)
                    return;
                consecutiveUnauthorized.current = 0;
                setError(null);
            })
                .catch((e) => {
                if (!active)
                    return;
                if (isUnauthorizedError(e)) {
                    consecutiveUnauthorized.current += 1;
                    if (consecutiveUnauthorized.current >= 2) {
                        setStopped(true);
                        setError(SESSION_EXPIRED);
                    }
                    return;
                }
                setError(e instanceof Error ? e.message : "load failed");
            })
                .finally(() => {
                inFlight.current = false;
            });
        };
        run();
        const id = setInterval(run, intervalMs);
        return () => {
            active = false;
            clearInterval(id);
        };
    }, [load, intervalMs, stopped]);
    const badgeClass = stopped ? "ops-badge-neutral" : error ? "ops-badge-degraded" : "ops-live";
    const badgeText = stopped ? "paused" : error ? "degraded" : "live";
    return (_jsxs("section", { className: "ops-panel", "data-lumora-panel-status": badgeText, children: [_jsxs("header", { className: "ops-panel-head", children: [_jsx("h2", { children: title }), _jsx("span", { className: badgeClass, children: badgeText })] }), error ? (_jsx("p", { className: "ops-error", role: "alert", children: error })) : null, children] }));
}
export function DataTable({ columns, rows, empty = "No rows yet.", highlightRow, }) {
    if (rows.length === 0) {
        return _jsx("p", { className: "ops-empty muted", children: empty });
    }
    return (_jsx("div", { className: "ops-table-wrap", children: _jsxs("table", { className: "ops-table", children: [_jsx("thead", { children: _jsx("tr", { children: columns.map((c) => (_jsx("th", { scope: "col", children: c }, c))) }) }), _jsx("tbody", { children: rows.map((row, i) => (_jsx("tr", { className: highlightRow === i ? "ops-row-flash" : undefined, children: row.map((cell, j) => (_jsx("td", { children: cell }, j))) }, i))) })] }) }));
}
//# sourceMappingURL=LivePanel.js.map